import { useParams } from 'react-router';
import { useGetBookingQuery } from 'drycut-graphql';
import { BookingDetails, BookingUnavailable } from 'booking/components';
import { useDocumentTitle } from 'usehooks-ts';
import { Loader } from 'ui-components';
import BookingPubSubWrapper from '../BookingPubSubWrapper';

export function BookingDetailsByUid(): React.ReactElement {
  useDocumentTitle('DRYCUT - Booking details');

  const { uid } = useParams() as { uid: string };
  const { data, loading } = useGetBookingQuery({ variables: { uid } });

  if (loading) {
    return <Loader />;
  }

  if (!data?.booking) {
    return <BookingUnavailable />;
  }

  return (
    <BookingPubSubWrapper uid={uid}>
      <BookingDetails booking={data?.booking} manual />
    </BookingPubSubWrapper>
  );
}
